import React, { useState } from 'react';
import { Message } from 'semantic-ui-react';
import './Alert.scss';

function Alert({ errorMessage, styleType }) {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  const styleClass = styleType === 'blue'
    ? 'custom-blue-message'
    : styleType === 'yellow'
    ? 'custom-yellow-message'
    : 'custom-red-message'; 

  return (
    <div className="custom-message-container">
      <Message className={`custom-message ${styleClass}`}>
        <div className={`close-icon-${styleType}`} onClick={() => setVisible(false)} />
        <span className="message-content">{errorMessage}</span>
      </Message>
    </div>
  );
}

export default Alert;
